/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

/* Icons */
import WarningAmberTwoToneIcon from "@mui/icons-material/WarningAmberTwoTone";

/* Styles */
import * as styles from "../Notifications/NotificationsStyle";
import {changeRenderType} from "../../store/actions";

/* Store */
const mapState = (reducer) => ({
    renderType: reducer?.renderType,
    statusInfo: reducer?.statusInfo,
    showPasswordExpireSoonError:reducer?.passwordExpirationError,
    tradingType: reducer?.tradingType
});

const Notifications = ({ sessionExpire, daysLeftForPasswordExpiration }) => {
    const dispatch = useDispatch();

    const { renderType, statusInfo, showPasswordExpireSoonError } = useSelector(mapState);

    /* Change classname based on statusInfo changes */
    useEffect(() => {
        properClassBasedOnStatus();
    }, [statusInfo]);

    /* Return proper class based on status */
    const properClassBasedOnStatus = () => {
        if (typeof statusInfo?.trading_enabled !== 'undefined' && !statusInfo?.trading_enabled) {
            return 'warning';
        }

        if (typeof statusInfo?.up_to_date !== 'undefined' && !statusInfo?.up_to_date) {
            return 'error';
        }

        return null;
    }

    /* Render element based on @type */
    const handleRenderType = (type) => {
        if (type !== renderType) {
            dispatch(changeRenderType(type));
        }
    }

    return (
      <React.Fragment>
          {(properClassBasedOnStatus() || sessionExpire || showPasswordExpireSoonError) && renderType === 'intraday' &&
              <div css={styles.notificationHolder}>
                  <WarningAmberTwoToneIcon css={styles.warningIcon} className="error" />

                  <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                      {properClassBasedOnStatus() && statusInfo?.message && ( <span css={styles.statusMessage} className={'default'}> *{statusInfo?.message} </span> )}

                      {sessionExpire && ( <span css={styles.statusMessage} className={'default'}>* Остават по-малко от 10 мин до вашата сесия. </span> )}

                      {showPasswordExpireSoonError && (
                          <span css={styles.statusMessage} className={'default'}>
                                *Паролата изтича след {daysLeftForPasswordExpiration} дни.
                                <span onClick={() => handleRenderType('resetPassword')} css={styles.link}>смяна</span>
                          </span>
                      )}
                  </div>
              </div>
          }
      </React.Fragment>
    );
}

export default Notifications;